export enum SplashTranslateKeyEnum {
    KEY_ALREADY_USE_BY_ANOTHER_REGISTRATOR = 'key_already_user_by_another_registrator',
    REGISTRATOR_ALREADY_LINKED_TO_ANOTHER_USER = 'registrator_already_linked_to_another_user',
    REGISTRATOR_ALREADY_LINKED_TO_ANOTHER_KEY = 'registrator_already_linked_to_another_key',
    GATEWAY_MANAGER_ADD_SUCCESS_ADMIN = 'gateway_manager_add_success_admin',
    GATEWAY_MANAGER_DELETE_GATEWAY_SUCCESS_ADMIN = 'gateway_manager_delete_gateway_success_admin',
    GATEWAY_MANAGER_DELETE_GATEWAY_ERROR_ADMIN = 'gateway_manager_delete_gateway_error_admin',
}

export class SplashMessageInterface {
    data: any;
    translateKey: SplashTranslateKeyEnum;
}
